import { render, staticRenderFns } from "./RiesgosAntisoborno.vue?vue&type=template&id=c151fe72&"
import script from "./RiesgosAntisoborno.vue?vue&type=script&lang=js&"
export * from "./RiesgosAntisoborno.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports